import React from 'react';

import { Grid, Typography, Tooltip } from '@mui/material';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import { SelectFilterChipPropTypes } from 'src/interfaces/iproptypes';

const SelectFilterChip = ({
  height,
  width,
  colors,
  text,
  handleOnClick,
  isSelected,
  borderRadius,
  fontWeight,
  tooltip,
  fontSize,
}: SelectFilterChipPropTypes) => {
  return (
    <Tooltip title={tooltip}>
      <div
        style={{
          position: 'relative',
          top: 0,
          left: 0,
          width: width ? width : '80px',
          height: height ? height : '30px',
          background: isSelected ? colors.color : colors.backgroundColor,
          border: isSelected ? `2px solid ${colors.color}` : `2px solid ${colors.borderColor}`,
          color: isSelected ? colors.backgroundColor : colors.color,
          borderRadius: borderRadius ? borderRadius : 100,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transition: 'background 0.3s ease, color 0.3s ease',
          cursor: 'pointer',
        }}
        onClick={handleOnClick}
      >
        {isSelected && (
          <div
            style={{
              width: 15,
              height: 15,
              borderRadius: 50,
              background: 'black',
              position: 'absolute',
              top: -10,
              right: -10,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              padding: 5,
            }}
          >
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ width: '100%', height: '100%' }}
            >
              <DoneRoundedIcon sx={{ color: 'white', width: 15, height: 15 }} />
            </Grid>
          </div>
        )}
        <Typography
          variant="body1"
          sx={{
            color: isSelected ? colors.backgroundColor : colors.color,
            fontWeight: fontWeight ? fontWeight : 900,
            fontSize: fontSize? fontSize : ''
          }}
        >
          {text}
        </Typography>
      </div>
    </Tooltip>
  );
};

export default SelectFilterChip;
